import {Container} from '@mui/material';
import ReactMarkdown from 'react-markdown';

export interface TextOnlyPageProps {
  mdText: string;
}

export default function TextOnlyMarkdownPage({mdText}: TextOnlyPageProps) {
  return (
    <Container maxWidth="md">
      <ReactMarkdown>{mdText}</ReactMarkdown>
    </Container>
  );
}
